// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* EduGenie floating chat widget */

.edugenie-root {
  --eg-red: #b32025;
  --eg-red-dark: #8f1a1e;
  --eg-red-light: #d4282e;
  --eg-red-soft: #fdf3f3;
  --eg-purple: #7c3aed;
  --eg-z: 1080;
  font-family: 'Segoe UI', system-ui, -apple-system, sans-serif;
}

.edugenie-root[data-theme='light'] {
  --eg-bg: #ffffff;
  --eg-bg-secondary: #f8fafc;
  --eg-border: #e2e8f0;
  --eg-text: #0f172a;
  --eg-text-muted: #64748b;
  --eg-user-bg: #b32025;
  --eg-user-text: #ffffff;
  --eg-bot-bg: #f1f5f9;
  --eg-bot-text: #0f172a;
  --eg-header-bg: linear-gradient(135deg, #b32025 0%, #8f1a1e 100%);
  --eg-header-text: #ffffff;
  --eg-shadow: 0 20px 50px rgba(15, 23, 42, 0.18);
  --eg-input-bg: #ffffff;
  --eg-chip-bg: #ffffff;
  --eg-chip-border: #e2e8f0;
  --eg-chip-hover: #fdf3f3;
  --eg-error-bg: #fef2f2;
  --eg-error-text: #991b1b;
}

.edugenie-root[data-theme='dark'] {
  --eg-bg: #0f172a;
  --eg-bg-secondary: #1e293b;
  --eg-border: #334155;
  --eg-text: #f8fafc;
  --eg-text-muted: #94a3b8;
  --eg-user-bg: #b32025;
  --eg-user-text: #ffffff;
  --eg-bot-bg: #1e293b;
  --eg-bot-text: #e2e8f0;
  --eg-header-bg: linear-gradient(135deg, #8f1a1e 0%, #5c1012 100%);
  --eg-header-text: #ffffff;
  --eg-shadow: 0 20px 50px rgba(0, 0, 0, 0.45);
  --eg-input-bg: #1e293b;
  --eg-chip-bg: #1e293b;
  --eg-chip-border: #334155;
  --eg-chip-hover: #334155;
  --eg-error-bg: #450a0a;
  --eg-error-text: #fecaca;
}

.edugenie-launcher {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: var(--eg-z);
  width: 96px;
  height: 96px;
  border: 3px solid #fff;
  border-radius: 50%;
  background: linear-gradient(145deg, var(--eg-red-light, #d4282e) 0%, var(--eg-red) 45%, var(--eg-red-dark) 100%);
  color: #fff;
  box-shadow:
    0 12px 32px rgba(179, 32, 37, 0.42),
    0 0 0 4px rgba(179, 32, 37, 0.12);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  padding: 0;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.edugenie-launcher:hover,
.edugenie-launcher:focus-visible {
  transform: translateY(-3px) scale(1.05);
  box-shadow:
    0 16px 36px rgba(179, 32, 37, 0.55),
    0 0 0 5px rgba(179, 32, 37, 0.16);
  outline: none;
}

.edugenie-launcher:focus-visible {
  box-shadow: 0 0 0 3px #fff, 0 0 0 7px rgba(179, 32, 37, 0.45);
}

.edugenie-launcher-img,
.edugenie-brand-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center top;
  display: block;
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
}

.edugenie-badge {
  position: absolute;
  top: 2px;
  right: 2px;
  min-width: 24px;
  height: 24px;
  padding: 0 6px;
  border-radius: 999px;
  background: var(--eg-red);
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #fff;
  animation: eg-badge-pop 0.35s ease;
}

.edugenie-window {
  position: fixed;
  right: 20px;
  bottom: 132px;
  z-index: var(--eg-z);
  width: min(400px, calc(100vw - 24px));
  height: min(620px, calc(100vh - 160px));
  background: var(--eg-bg);
  color: var(--eg-text);
  border-radius: 20px;
  border: 1px solid var(--eg-border);
  box-shadow: var(--eg-shadow);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  animation: eg-slide-up 0.28s ease;
}

.edugenie-header {
  background: linear-gradient(135deg, var(--eg-red-light) 0%, var(--eg-red) 48%, var(--eg-red-dark) 100%);
  color: var(--eg-header-text);
  padding: 14px 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
  position: relative;
}

.edugenie-header::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 3px;
  background: linear-gradient(90deg, var(--eg-purple), rgba(255, 255, 255, 0.35), var(--eg-purple));
  opacity: 0.85;
}

.edugenie-header-avatar {
  width: 46px;
  height: 46px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.95);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  overflow: hidden;
  border: 2px solid rgba(255, 255, 255, 0.85);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.edugenie-header-meta {
  flex: 1 1;
  min-width: 0;
}

.edugenie-header-title {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.2;
}

.edugenie-header-subtitle {
  margin: 2px 0 0;
  font-size: 12px;
  opacity: 0.95;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.edugenie-liberate-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 5px;
  padding: 2px 8px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.18);
  border: 1px solid rgba(255, 255, 255, 0.28);
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  line-height: 1.3;
}

.edugenie-panel-sep {
  opacity: 0.65;
}

.edugenie-panel-label {
  font-weight: 700;
  opacity: 0.95;
}

.edugenie-liberate-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 0 0 2px rgba(124, 58, 237, 0.55);
}

.edugenie-header-actions {
  display: flex;
  align-items: center;
  gap: 4px;
}

.edugenie-icon-btn {
  width: 34px;
  height: 34px;
  border: none;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.14);
  color: inherit;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.15s ease;
}

.edugenie-icon-btn:hover,
.edugenie-icon-btn:focus-visible {
  background: rgba(255, 255, 255, 0.28);
  outline: none;
}

.edugenie-body {
  flex: 1 1;
  overflow-y: auto;
  padding: 16px;
  background: var(--eg-bg-secondary);
  scroll-behavior: smooth;
}

.edugenie-greeting {
  background: var(--eg-bg);
  border: 1px solid var(--eg-border);
  border-left: 4px solid var(--eg-red);
  border-radius: 16px;
  padding: 14px;
  margin-bottom: 14px;
  white-space: pre-wrap;
  font-size: 13.5px;
  line-height: 1.55;
  color: var(--eg-text);
  animation: eg-fade-in 0.35s ease;
  box-shadow: 0 4px 14px rgba(179, 32, 37, 0.06);
}

.edugenie-msg-row {
  display: flex;
  gap: 8px;
  margin-bottom: 14px;
  animation: eg-fade-in 0.25s ease;
}

.edugenie-msg-row.is-user {
  flex-direction: row-reverse;
}

.edugenie-avatar {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 700;
  overflow: hidden;
}

.edugenie-avatar.is-bot {
  background: var(--eg-red-soft);
  color: var(--eg-red);
  border: 1px solid rgba(179, 32, 37, 0.22);
  padding: 0;
}

.edugenie-avatar.is-user {
  background: #334155;
  color: #fff;
}

.edugenie-bubble {
  max-width: min(82%, 300px);
  padding: 10px 12px;
  border-radius: 16px;
  font-size: 13.5px;
  line-height: 1.5;
  white-space: pre-wrap;
  word-break: break-word;
}

.edugenie-msg-row.is-bot .edugenie-bubble {
  background: var(--eg-bot-bg);
  color: var(--eg-bot-text);
  border-bottom-left-radius: 4px;
  max-width: min(92%, 340px);
}

.edugenie-msg-row.is-user .edugenie-bubble {
  background: var(--eg-user-bg);
  color: var(--eg-user-text);
  border-bottom-right-radius: 4px;
}

.edugenie-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 4px;
  font-size: 11px;
  color: var(--eg-text-muted);
}

.edugenie-msg-row.is-user .edugenie-meta {
  justify-content: flex-end;
}

.edugenie-feedback {
  display: inline-flex;
  gap: 4px;
}

.edugenie-feedback button {
  border: none;
  background: transparent;
  color: var(--eg-text-muted);
  padding: 2px;
  cursor: pointer;
  border-radius: 6px;
}

.edugenie-feedback button:hover,
.edugenie-feedback button:focus-visible,
.edugenie-feedback button.is-active {
  color: var(--eg-red);
  outline: none;
}

.edugenie-error-box {
  background: var(--eg-error-bg);
  color: var(--eg-error-text);
  border-radius: 12px;
  padding: 10px 12px;
  font-size: 13px;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.edugenie-retry-btn {
  border: 1px solid currentColor;
  background: transparent;
  color: inherit;
  border-radius: 8px;
  padding: 4px 10px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
}

.edugenie-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 4px 0 12px;
}

.edugenie-chip {
  border: 1px solid var(--eg-chip-border);
  background: var(--eg-chip-bg);
  color: var(--eg-text);
  border-radius: 999px;
  padding: 6px 12px;
  font-size: 12px;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.edugenie-chip:hover,
.edugenie-chip:focus-visible {
  background: var(--eg-chip-hover);
  border-color: var(--eg-red);
  outline: none;
}

.edugenie-typing {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 10px 14px;
  background: var(--eg-bot-bg);
  border-radius: 16px;
  border-bottom-left-radius: 4px;
}

.edugenie-typing span {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--eg-text-muted);
  animation: eg-typing 1.2s infinite ease-in-out;
}

.edugenie-typing span:nth-child(2) { animation-delay: 0.15s; }
.edugenie-typing span:nth-child(3) { animation-delay: 0.3s; }

.edugenie-footer {
  border-top: 1px solid var(--eg-border);
  background: var(--eg-bg);
  padding: 12px;
  flex-shrink: 0;
}

.edugenie-composer {
  display: flex;
  align-items: flex-end;
  gap: 8px;
}

.edugenie-input {
  flex: 1 1;
  min-height: 42px;
  max-height: 110px;
  resize: none;
  border: 1px solid var(--eg-border);
  background: var(--eg-input-bg);
  color: var(--eg-text);
  border-radius: 14px;
  padding: 10px 12px;
  font-size: 14px;
  line-height: 1.4;
}

.edugenie-input:focus {
  outline: none;
  border-color: var(--eg-red);
  box-shadow: 0 0 0 3px rgba(179, 32, 37, 0.15);
}

.edugenie-send {
  width: 42px;
  height: 42px;
  border: none;
  border-radius: 14px;
  background: var(--eg-red);
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.15s ease, opacity 0.15s ease;
}

.edugenie-send:hover:not(:disabled),
.edugenie-send:focus-visible:not(:disabled) {
  background: var(--eg-red-dark);
  outline: none;
}

.edugenie-send:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.edugenie-footer-hint {
  margin: 6px 0 0;
  font-size: 11px;
  color: var(--eg-text-muted);
  text-align: center;
}

.edugenie-liberate-footer {
  margin: 8px 0 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 11px;
  font-weight: 600;
  color: var(--eg-text-muted);
}

.edugenie-liberate-footer strong {
  color: var(--eg-red);
  letter-spacing: 0.02em;
}

.edugenie-liberate-footer span.sep {
  opacity: 0.4;
}

.edugenie-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 40px 16px;
  color: var(--eg-text-muted);
  font-size: 13px;
}

@keyframes eg-slide-up {
  from { opacity: 0; transform: translateY(16px) scale(0.98); }
  to { opacity: 1; transform: translateY(0) scale(1); }
}

@keyframes eg-fade-in {
  from { opacity: 0; transform: translateY(6px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes eg-typing {
  0%, 80%, 100% { transform: translateY(0); opacity: 0.4; }
  40% { transform: translateY(-4px); opacity: 1; }
}

@keyframes eg-badge-pop {
  from { transform: scale(0.5); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
}

@media (max-width: 576px) {
  .edugenie-launcher {
    right: 14px;
    bottom: 14px;
    width: 84px;
    height: 84px;
  }

  .edugenie-window {
    right: 0;
    bottom: 0;
    width: 100vw;
    height: 100vh;
    height: 100dvh;
    border-radius: 0;
    border: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/edugenie/edugenie.css"],"names":[],"mappings":"AAAA,kCAAkC;;AAElC;EACE,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;EACvB,sBAAsB;EACtB,oBAAoB;EACpB,YAAY;EACZ,6DAA6D;AAC/D;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,oBAAoB;EACpB,kBAAkB;EAClB,wBAAwB;EACxB,qBAAqB;EACrB,uBAAuB;EACvB,oBAAoB;EACpB,sBAAsB;EACtB,iEAAiE;EACjE,yBAAyB;EACzB,+CAA+C;EAC/C,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;EACzB,wBAAwB;EACxB,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,oBAAoB;EACpB,kBAAkB;EAClB,wBAAwB;EACxB,qBAAqB;EACrB,uBAAuB;EACvB,oBAAoB;EACpB,sBAAsB;EACtB,iEAAiE;EACjE,yBAAyB;EACzB,4CAA4C;EAC5C,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;EACzB,wBAAwB;EACxB,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,gHAAgH;EAChH,WAAW;EACX;;qCAEmC;EACnC,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,UAAU;EACV,qDAAqD;AACvD;;AAEA;;EAEE,uCAAuC;EACvC;;qCAEmC;EACnC,aAAa;AACf;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,2BAA2B;EAC3B,cAAc;EACd,oBAAoB;EACpB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,eAAe;EACf,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,WAAW;EACX,aAAa;EACb,oBAAoB;EACpB,qCAAqC;EACrC,uCAAuC;EACvC,wBAAwB;EACxB,qBAAqB;EACrB,mBAAmB;EACnB,kCAAkC;EAClC,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,uGAAuG;EACvG,4BAA4B;EAC5B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,WAAW;EACX,iGAAiG;EACjG,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,2CAA2C;EAC3C,yCAAyC;AAC3C;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,qCAAqC;EACrC,2CAA2C;EAC3C,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;EACrC,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iCAAiC;AACnC;;AAEA;;EAEE,qCAAqC;EACrC,aAAa;AACf;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;EAClC,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;EACrB,gCAAgC;EAChC,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,oBAAoB;EACpB,yCAAyC;EACzC,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,2BAA2B;EAC3B,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;;;EAGE,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;EACvC,6BAA6B;EAC7B,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,0DAA0D;AAC5D;;AAEA;;EAEE,gCAAgC;EAChC,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,4BAA4B;EAC5B,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,gCAAgC;EAChC,8CAA8C;AAChD;;AAEA,qCAAqC,sBAAsB,EAAE;AAC7D,qCAAqC,qBAAqB,EAAE;;AAE5D;EACE,sCAAsC;EACtC,wBAAwB;EACxB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,kCAAkC;EAClC,8BAA8B;EAC9B,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,qDAAqD;AACvD;;AAEA;;EAEE,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,KAAK,UAAU,EAAE,iCAAiC,EAAE;AACtD;;AAEA;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,gBAAgB,wBAAwB,EAAE,YAAY,EAAE;EACxD,MAAM,2BAA2B,EAAE,UAAU,EAAE;AACjD;;AAEA;EACE,OAAO,qBAAqB,EAAE,UAAU,EAAE;EAC1C,KAAK,mBAAmB,EAAE,UAAU,EAAE;AACxC;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,WAAW;IACX,YAAY;EACd;;EAEA;IACE,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,aAAa;IACb,cAAc;IACd,gBAAgB;IAChB,YAAY;EACd;AACF","sourcesContent":["/* EduGenie floating chat widget */\n\n.edugenie-root {\n  --eg-red: #b32025;\n  --eg-red-dark: #8f1a1e;\n  --eg-red-light: #d4282e;\n  --eg-red-soft: #fdf3f3;\n  --eg-purple: #7c3aed;\n  --eg-z: 1080;\n  font-family: 'Segoe UI', system-ui, -apple-system, sans-serif;\n}\n\n.edugenie-root[data-theme='light'] {\n  --eg-bg: #ffffff;\n  --eg-bg-secondary: #f8fafc;\n  --eg-border: #e2e8f0;\n  --eg-text: #0f172a;\n  --eg-text-muted: #64748b;\n  --eg-user-bg: #b32025;\n  --eg-user-text: #ffffff;\n  --eg-bot-bg: #f1f5f9;\n  --eg-bot-text: #0f172a;\n  --eg-header-bg: linear-gradient(135deg, #b32025 0%, #8f1a1e 100%);\n  --eg-header-text: #ffffff;\n  --eg-shadow: 0 20px 50px rgba(15, 23, 42, 0.18);\n  --eg-input-bg: #ffffff;\n  --eg-chip-bg: #ffffff;\n  --eg-chip-border: #e2e8f0;\n  --eg-chip-hover: #fdf3f3;\n  --eg-error-bg: #fef2f2;\n  --eg-error-text: #991b1b;\n}\n\n.edugenie-root[data-theme='dark'] {\n  --eg-bg: #0f172a;\n  --eg-bg-secondary: #1e293b;\n  --eg-border: #334155;\n  --eg-text: #f8fafc;\n  --eg-text-muted: #94a3b8;\n  --eg-user-bg: #b32025;\n  --eg-user-text: #ffffff;\n  --eg-bot-bg: #1e293b;\n  --eg-bot-text: #e2e8f0;\n  --eg-header-bg: linear-gradient(135deg, #8f1a1e 0%, #5c1012 100%);\n  --eg-header-text: #ffffff;\n  --eg-shadow: 0 20px 50px rgba(0, 0, 0, 0.45);\n  --eg-input-bg: #1e293b;\n  --eg-chip-bg: #1e293b;\n  --eg-chip-border: #334155;\n  --eg-chip-hover: #334155;\n  --eg-error-bg: #450a0a;\n  --eg-error-text: #fecaca;\n}\n\n.edugenie-launcher {\n  position: fixed;\n  right: 20px;\n  bottom: 20px;\n  z-index: var(--eg-z);\n  width: 96px;\n  height: 96px;\n  border: 3px solid #fff;\n  border-radius: 50%;\n  background: linear-gradient(145deg, var(--eg-red-light, #d4282e) 0%, var(--eg-red) 45%, var(--eg-red-dark) 100%);\n  color: #fff;\n  box-shadow:\n    0 12px 32px rgba(179, 32, 37, 0.42),\n    0 0 0 4px rgba(179, 32, 37, 0.12);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  padding: 0;\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.edugenie-launcher:hover,\n.edugenie-launcher:focus-visible {\n  transform: translateY(-3px) scale(1.05);\n  box-shadow:\n    0 16px 36px rgba(179, 32, 37, 0.55),\n    0 0 0 5px rgba(179, 32, 37, 0.16);\n  outline: none;\n}\n\n.edugenie-launcher:focus-visible {\n  box-shadow: 0 0 0 3px #fff, 0 0 0 7px rgba(179, 32, 37, 0.45);\n}\n\n.edugenie-launcher-img,\n.edugenie-brand-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center top;\n  display: block;\n  pointer-events: none;\n  user-select: none;\n}\n\n.edugenie-badge {\n  position: absolute;\n  top: 2px;\n  right: 2px;\n  min-width: 24px;\n  height: 24px;\n  padding: 0 6px;\n  border-radius: 999px;\n  background: var(--eg-red);\n  color: #fff;\n  font-size: 12px;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 2px solid #fff;\n  animation: eg-badge-pop 0.35s ease;\n}\n\n.edugenie-window {\n  position: fixed;\n  right: 20px;\n  bottom: 132px;\n  z-index: var(--eg-z);\n  width: min(400px, calc(100vw - 24px));\n  height: min(620px, calc(100vh - 160px));\n  background: var(--eg-bg);\n  color: var(--eg-text);\n  border-radius: 20px;\n  border: 1px solid var(--eg-border);\n  box-shadow: var(--eg-shadow);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  animation: eg-slide-up 0.28s ease;\n}\n\n.edugenie-header {\n  background: linear-gradient(135deg, var(--eg-red-light) 0%, var(--eg-red) 48%, var(--eg-red-dark) 100%);\n  color: var(--eg-header-text);\n  padding: 14px 16px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-shrink: 0;\n  position: relative;\n}\n\n.edugenie-header::after {\n  content: '';\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  height: 3px;\n  background: linear-gradient(90deg, var(--eg-purple), rgba(255, 255, 255, 0.35), var(--eg-purple));\n  opacity: 0.85;\n}\n\n.edugenie-header-avatar {\n  width: 46px;\n  height: 46px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.95);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  overflow: hidden;\n  border: 2px solid rgba(255, 255, 255, 0.85);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n}\n\n.edugenie-header-meta {\n  flex: 1;\n  min-width: 0;\n}\n\n.edugenie-header-title {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 1.2;\n}\n\n.edugenie-header-subtitle {\n  margin: 2px 0 0;\n  font-size: 12px;\n  opacity: 0.95;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.edugenie-liberate-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: 5px;\n  padding: 2px 8px;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.18);\n  border: 1px solid rgba(255, 255, 255, 0.28);\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  line-height: 1.3;\n}\n\n.edugenie-panel-sep {\n  opacity: 0.65;\n}\n\n.edugenie-panel-label {\n  font-weight: 700;\n  opacity: 0.95;\n}\n\n.edugenie-liberate-dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: #fff;\n  box-shadow: 0 0 0 2px rgba(124, 58, 237, 0.55);\n}\n\n.edugenie-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.edugenie-icon-btn {\n  width: 34px;\n  height: 34px;\n  border: none;\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.14);\n  color: inherit;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n\n.edugenie-icon-btn:hover,\n.edugenie-icon-btn:focus-visible {\n  background: rgba(255, 255, 255, 0.28);\n  outline: none;\n}\n\n.edugenie-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 16px;\n  background: var(--eg-bg-secondary);\n  scroll-behavior: smooth;\n}\n\n.edugenie-greeting {\n  background: var(--eg-bg);\n  border: 1px solid var(--eg-border);\n  border-left: 4px solid var(--eg-red);\n  border-radius: 16px;\n  padding: 14px;\n  margin-bottom: 14px;\n  white-space: pre-wrap;\n  font-size: 13.5px;\n  line-height: 1.55;\n  color: var(--eg-text);\n  animation: eg-fade-in 0.35s ease;\n  box-shadow: 0 4px 14px rgba(179, 32, 37, 0.06);\n}\n\n.edugenie-msg-row {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 14px;\n  animation: eg-fade-in 0.25s ease;\n}\n\n.edugenie-msg-row.is-user {\n  flex-direction: row-reverse;\n}\n\n.edugenie-avatar {\n  width: 34px;\n  height: 34px;\n  border-radius: 50%;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 13px;\n  font-weight: 700;\n  overflow: hidden;\n}\n\n.edugenie-avatar.is-bot {\n  background: var(--eg-red-soft);\n  color: var(--eg-red);\n  border: 1px solid rgba(179, 32, 37, 0.22);\n  padding: 0;\n}\n\n.edugenie-avatar.is-user {\n  background: #334155;\n  color: #fff;\n}\n\n.edugenie-bubble {\n  max-width: min(82%, 300px);\n  padding: 10px 12px;\n  border-radius: 16px;\n  font-size: 13.5px;\n  line-height: 1.5;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.edugenie-msg-row.is-bot .edugenie-bubble {\n  background: var(--eg-bot-bg);\n  color: var(--eg-bot-text);\n  border-bottom-left-radius: 4px;\n  max-width: min(92%, 340px);\n}\n\n.edugenie-msg-row.is-user .edugenie-bubble {\n  background: var(--eg-user-bg);\n  color: var(--eg-user-text);\n  border-bottom-right-radius: 4px;\n}\n\n.edugenie-meta {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 4px;\n  font-size: 11px;\n  color: var(--eg-text-muted);\n}\n\n.edugenie-msg-row.is-user .edugenie-meta {\n  justify-content: flex-end;\n}\n\n.edugenie-feedback {\n  display: inline-flex;\n  gap: 4px;\n}\n\n.edugenie-feedback button {\n  border: none;\n  background: transparent;\n  color: var(--eg-text-muted);\n  padding: 2px;\n  cursor: pointer;\n  border-radius: 6px;\n}\n\n.edugenie-feedback button:hover,\n.edugenie-feedback button:focus-visible,\n.edugenie-feedback button.is-active {\n  color: var(--eg-red);\n  outline: none;\n}\n\n.edugenie-error-box {\n  background: var(--eg-error-bg);\n  color: var(--eg-error-text);\n  border-radius: 12px;\n  padding: 10px 12px;\n  font-size: 13px;\n  margin-bottom: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.edugenie-retry-btn {\n  border: 1px solid currentColor;\n  background: transparent;\n  color: inherit;\n  border-radius: 8px;\n  padding: 4px 10px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.edugenie-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin: 4px 0 12px;\n}\n\n.edugenie-chip {\n  border: 1px solid var(--eg-chip-border);\n  background: var(--eg-chip-bg);\n  color: var(--eg-text);\n  border-radius: 999px;\n  padding: 6px 12px;\n  font-size: 12px;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease;\n}\n\n.edugenie-chip:hover,\n.edugenie-chip:focus-visible {\n  background: var(--eg-chip-hover);\n  border-color: var(--eg-red);\n  outline: none;\n}\n\n.edugenie-typing {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 10px 14px;\n  background: var(--eg-bot-bg);\n  border-radius: 16px;\n  border-bottom-left-radius: 4px;\n}\n\n.edugenie-typing span {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: var(--eg-text-muted);\n  animation: eg-typing 1.2s infinite ease-in-out;\n}\n\n.edugenie-typing span:nth-child(2) { animation-delay: 0.15s; }\n.edugenie-typing span:nth-child(3) { animation-delay: 0.3s; }\n\n.edugenie-footer {\n  border-top: 1px solid var(--eg-border);\n  background: var(--eg-bg);\n  padding: 12px;\n  flex-shrink: 0;\n}\n\n.edugenie-composer {\n  display: flex;\n  align-items: flex-end;\n  gap: 8px;\n}\n\n.edugenie-input {\n  flex: 1;\n  min-height: 42px;\n  max-height: 110px;\n  resize: none;\n  border: 1px solid var(--eg-border);\n  background: var(--eg-input-bg);\n  color: var(--eg-text);\n  border-radius: 14px;\n  padding: 10px 12px;\n  font-size: 14px;\n  line-height: 1.4;\n}\n\n.edugenie-input:focus {\n  outline: none;\n  border-color: var(--eg-red);\n  box-shadow: 0 0 0 3px rgba(179, 32, 37, 0.15);\n}\n\n.edugenie-send {\n  width: 42px;\n  height: 42px;\n  border: none;\n  border-radius: 14px;\n  background: var(--eg-red);\n  color: #fff;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  flex-shrink: 0;\n  transition: background 0.15s ease, opacity 0.15s ease;\n}\n\n.edugenie-send:hover:not(:disabled),\n.edugenie-send:focus-visible:not(:disabled) {\n  background: var(--eg-red-dark);\n  outline: none;\n}\n\n.edugenie-send:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.edugenie-footer-hint {\n  margin: 6px 0 0;\n  font-size: 11px;\n  color: var(--eg-text-muted);\n  text-align: center;\n}\n\n.edugenie-liberate-footer {\n  margin: 8px 0 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--eg-text-muted);\n}\n\n.edugenie-liberate-footer strong {\n  color: var(--eg-red);\n  letter-spacing: 0.02em;\n}\n\n.edugenie-liberate-footer span.sep {\n  opacity: 0.4;\n}\n\n.edugenie-loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  padding: 40px 16px;\n  color: var(--eg-text-muted);\n  font-size: 13px;\n}\n\n@keyframes eg-slide-up {\n  from { opacity: 0; transform: translateY(16px) scale(0.98); }\n  to { opacity: 1; transform: translateY(0) scale(1); }\n}\n\n@keyframes eg-fade-in {\n  from { opacity: 0; transform: translateY(6px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n@keyframes eg-typing {\n  0%, 80%, 100% { transform: translateY(0); opacity: 0.4; }\n  40% { transform: translateY(-4px); opacity: 1; }\n}\n\n@keyframes eg-badge-pop {\n  from { transform: scale(0.5); opacity: 0; }\n  to { transform: scale(1); opacity: 1; }\n}\n\n@media (max-width: 576px) {\n  .edugenie-launcher {\n    right: 14px;\n    bottom: 14px;\n    width: 84px;\n    height: 84px;\n  }\n\n  .edugenie-window {\n    right: 0;\n    bottom: 0;\n    width: 100vw;\n    height: 100vh;\n    height: 100dvh;\n    border-radius: 0;\n    border: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
